<template>
  <c-view>
    <c-page>
      <c-navbar></c-navbar>
      <c-content>
        <c-cell-container class="mg-0" v-if="listDatas.length > 0" v-scroll-load>
          <c-cell class="cell-item"
                  v-for="(item,index) in listDatas"
                  :key="index"
                  :icon="item.orderIcon" :title="item.orderTitle"
                  :desc="item.orderStatus" :class="item.orderStatusType"
                  @click.native="itemClick(item,index)">
          </c-cell>
        </c-cell-container>
        <div class="empty" v-else>
          暂无订单记录
        </div>
      </c-content>
    </c-page>
    <transition name="slide-right" mode="out-in">
      <router-view></router-view>
    </transition>
  </c-view>
</template>
<style lang="scss">
  @import "./index";
</style>
<script>
  import AboutUser from '../../../model/about-user'
  import Order from '../../../model/about-user/index'
  import event from '../../../tools/event'
  export default{
    data () {
      return {
        aboutUser: new AboutUser(),
        listDatas: [],
        clickItemIndex: -1
      }
    },
    components: {},
    created () {
      this.aboutUser.orderList().then(res => {
        this.listDatas = res
      })
      event.paySuccess.on(() => {
        if (this.clickItemIndex === -1) return
        this.listDatas[this.clickItemIndex] = new Order().orderItemChangeStatus(this.listDatas[this.clickItemIndex].originOrderItem)
        this.$store.commit('setOrderListItemDetail', this.listDatas[this.clickItemIndex])
      })
      this.$on('scrollLoadEvent', (a) => {
        console.log(a)
      })
    },
    mounted () {},
    beforeDestroy () {},
    methods: {
      itemClick (itemObj, index) {
        this.clickItemIndex = index
        this.$store.commit('setOrderListItemDetail', itemObj)
        this.$router.push({path: `${this.$route.path}/itemDetail`})
      }
    },
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?60f0e06c